function buildConsoleDataUrl(
  projectId: string,
  pathSegments: string[]
): string {
  const suffix = pathSegments.map(seg => `~2F${seg}`).join("");
  const enc = encodeURIComponent(projectId);
  return `https://console.firebase.google.com/u/0/project/${enc}/database/${enc}/data/${suffix}`;
}

export function charityRootConsoleUrl(
  mainProjectId: string,
  charityId: string
): string {
  return buildConsoleDataUrl(mainProjectId, [charityId]);
}

export function postConsoleUrl(
  mainProjectId: string,
  charityId: string,
  postCollection: "pendingPosts" | "publishedPosts",
  postId: string
): string {
  return buildConsoleDataUrl(mainProjectId, [
    charityId,
    postCollection,
    postId,
  ]);
}

export function donorConsoleUrl(
  childProjectId: string,
  charityId: string,
  donorId: string
): string {
  return buildConsoleDataUrl(childProjectId, [charityId, "donors", donorId]);
}

export function donationConsoleUrl(
  childProjectId: string,
  charityId: string,
  donationId: string
): string {
  return buildConsoleDataUrl(childProjectId, [charityId, "donations", donationId]);
}

export function fileRequestConsoleUrl(
  mainProjectId: string,
  charityId: string,
  requestId: string
): string {
  return buildConsoleDataUrl(mainProjectId, [
    charityId,
    "fileRequests",
    requestId,
  ]);
}
